import { render, staticRenderFns } from "./userRequest.vue?vue&type=template&id=35f704c0"
import script from "@/scripts/extraServiceRequest/userRequest.js?vue&type=script&lang=js&external"
export * from "@/scripts/extraServiceRequest/userRequest.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports